import React, {useContext, useEffect, useState} from 'react';
import {ISearchFilter, ISearchFilterSet} from '../../Foundations/Types/ISearchFilter';
import SearchFilter from './SearchFilter';
import searchFilterContext from '../../Foundations/Contexts/SearchFilterContext';
import Button from '../../Components/Button';

const FilterContainers: React.FC = () => {
    const { setActiveFilters, availableFilters, activeFilters } = useContext(searchFilterContext);
    const [filters, setFilters] = useState<ISearchFilterSet | null>(availableFilters);

    useEffect(() => {
        if (activeFilters !== null) {
            const newFilters: ISearchFilterSet = {...availableFilters, ...activeFilters}
            setFilters(newFilters);
        } else {
            const newFilters: ISearchFilterSet = {...availableFilters};
            Object.keys(newFilters).forEach((key) => {
                const filterItems = newFilters[key].items;
                if (typeof filterItems !== 'undefined') {
                    newFilters[key].items = filterItems.map((item) => {
                        item.selected = false;
                        return item;
                    })
                }
            })
            setFilters(newFilters);
        }
    }, [availableFilters, activeFilters])

    const handleSelectedFilter = (updatedFilter: ISearchFilter) => {
        setActiveFilters({ ...availableFilters, ...activeFilters, [updatedFilter.name]: updatedFilter});
    }

    const resetFilter = () => {
        setActiveFilters(null);
    }

    return (
        <div className="my-2 flex">
            <div className="w-10/12 flex flex-wrap items-center">
                {
                    filters !== null &&
                    Object.keys(filters).map((key: string, index: number) => (
                        <SearchFilter key={index} filter={filters[key]} onSelected={handleSelectedFilter} />
                    ))
                }
            </div>
            <div className="w-2/12 flex items-center justify-end">
                <Button onClick={() => resetFilter()}
                        text="Clear filters"
                        bg="bg-transparent"
                        width="w-auto"
                        justify="justify-end"
                        textStyle="text-gray-700 font-bold underline"
                />
            </div>
        </div>
    )
}

export default FilterContainers;
